/* @flow */

import getStore from './get-store';
import { buscarPendencias } from '../ducks/empresa';

const recarregarPendencias = () => {
    getStore().dispatch(buscarPendencias());
};

export default recarregarPendencias;
